<p-toast [life]="constantService.defaultToastLife"></p-toast>
<div (mouseleave)="onMouseOut('nav')">

  <nav class="navbar navbar-fixed-top nopadding navmenu" role="navigation">
  <div class="combogrouplist">
    <!-- Brand and toggle get grouped for better mobile  -->

    <div class='navbar-header'>

      <label>
        <div [ngClass]="isProductionEnv ? 'row row-box-mg' : 'row-without-prod'">
          <div>
            <span (mouseover)="mouseOver('home')" id="home" (click)="isActive('home')"
              [ngClass]="selectedItem === home ? 'nav nav-tabs active' :'navbar-brand active' ">
              <a routerLink="/pages/MainDashboard" class="logo">
                <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home"></mat-icon>
                <span class="RSMSName">RSMS</span>
              </a>
            </span>
            @if(isProductionEnv){
            <div class="col-md-12 color-red">
              <label for="isProductionEnv" class="mg-l"><b>{{isProductionEnv ? 'PROD': '  '}}</b></label>
            </div>
          }
          </div>
        </div>
      </label>
      <button type='button' class='navbar-toggle uarr collapsed menuicon' data-toggle='collapse'
        data-target='#myNavbar'>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
    </div>
    <!-- Mainmenu List -->
    <div class="collapse navbar-collapse menulist" id="myNavbar">
      <ul class="nav nav-tabs">
        @for(menu of MenuArray; track menu.menuType + '-'+ $index; let i = $index) { 
        <li
          [ngClass]="i === selected_main_menu_number ? 'float-left active ' : menu.menuType === tempActiveMenuName ? 'float-left tempActive' :'float-left'">
          <a (click)="mouseOver(menu.menuType); setMenuindex(i)" [id]="menu.menuType"
            routerLinkActive="active">{{menu.menuType}}
            @if(i === selected_main_menu_number || i === temp_active_main_menu_number){
            <i class="fa fa-caret-down fa-5x" aria-hidden="true"></i>
            }
            @if(i != selected_main_menu_number && i != temp_active_main_menu_number){
            <i class="fa fa-caret-right fa-5x"></i>
            }
          </a>
            
        </li>
        }

        <span class="nav nav-tabs display-no loguserinfo">
          <li [style]="{'padding-top': '1px !important'}">
            {{datePipe.transform(currentDate, 'MM/dd/yyyy')}}
          </li>
          <li [style]="{'padding-top': '1px !important'}">
                <p-autocomplete [(ngModel)]="MPID" [dropdown]="true" field="mpid" 
                [suggestions]="filterMPIDs" appendTo="body" [forceSelection]="true" emptyMessage="No data" 
                  (completeMethod)="filteredMPIDList($event)" [style]="{'text-transform': 'capitalize','height':'18px !important'}"
                  (onSelect)="onChange($event.value)" (onBlur)="onMPIDChange()" styleClass="mpid-panel-class" panelStyleClass="firmdropdownlist">
                </p-autocomplete>
          </li>
          <li [style]="{'padding-top': '1px !important'}">{{User}}</li>
           <li class="commentbtnWrapper" matTooltip="Notifications" matTooltipPosition="left" [style]="{'padding-top': '1px !important'}" (click)="showToastMessgae()">
            <em class="pi pi-bell textSize"></em>
            @if(hasUnread){
            <span class="btnBadge"></span>
            }
          </li>
          <li matTooltip="Log Out" [matTooltipShowDelay]="1000" matTooltipPosition="left" [style]="{'padding-top': '1px !important'}">
            <a id="logout" (click)="logout()">
              <span class="glyphicon glyphicon-log-out  dropdown-toggle" data-toggle="dropdown"></span>
            </a>
        </span>

      </ul>
      <!-- Main Submenu List -->
      <ul class="nav nav-tabs  table-container">
        @if(home){
        <span  [ngClass]="selectedItem === home ? 'nav  nav-tabs active ' : 'none' ">
          <div class="tempActive">
            <app-toolbar (click)="isActive('Toolbar')"></app-toolbar>
          </div>
        </span>
      }
      @if(!home){
        <span  [ngClass]="selectedItem != home ? 'nav nav-tabs active  ' : 'none' ">
          <div class="tempActive">
            <ul class="nav nav-tabs">
              @for(submenu of MenuArray[temp_active_main_menu_number]?.children; track submenu.subMunuName + '-'+ $index; let j = $index) { 
              <li
                [ngClass]="isActive_submenu === submenu.subMunuName  ? ' active ' : 'none' "
                (click)="isActive(submenu.subMunuName);setActiveMenuindex()">
                <a [id]="submenu.subMunuName" (click)="goToSubMenu(submenu.url)"
                  routerLinkActive="active">{{submenu.subMunuName}}
                </a>
              </li>
              }
            </ul>
          </div>
        

        <!-- File Process Buttons -->
        @if(showFileProcessbtn){
        <span class="nav nav-tabs table-container float-right display-no"  >
          @if((this.isActive_submenu == 'CAT ROE Viewer') ? !this.regUserInProduction : 'true'){
          <li>
          @if(getMainTabName() != 'CAIS'){
            <button  matTooltip="Start File Validation" [matTooltipShowDelay]="1000" matTooltipPosition="left" (click)="fileProcessing('Correction')"
              mat-raised-button class="resizeMatMenuBtn" [ngClass]="'btn-blue'" id="Validate"> Validate
            </button>
          }
          </li>
          }
        @if(getMainTabName() === 'CAIS'){
          <li>
            <button matTooltip="Start File Validation" [matTooltipShowDelay]="1000" matTooltipPosition="left" (click)="fileProcessing('Correction')"
              mat-raised-button class="resizeMatMenuBtn btn-blue" id="CAISValidateBtn"> Validate
            </button>
          </li>
        }
         @if((this.isActive_submenu == 'CAT ROE Viewer' || getMainTabName() === 'CAIS') ? !this.regUserInProduction : 'true'){
          <li>
            <button matTooltip="Start File Generation" [matTooltipShowDelay]="1000" class="resizeMatMenuBtn" [ngClass]="'btn-blue'" 
             matTooltipPosition="left" (click)="fileProcessing('Generate')"
              mat-raised-button color="primary" id="Generate">Generate
            </button>
          </li>
        } 
        @if((this.isActive_submenu == 'CAT ROE Viewer' || getMainTabName() === 'CAIS') ? !this.regUserInProduction : 'true'){
          <li>
            <button matTooltip="Submit File to FINRA" [matTooltipShowDelay]="1000" matTooltipPosition="left" class="resizeMatMenuBtn" [ngClass]="'btn-blue'" 
             (click)="fileProcessing('Submit')"
              mat-raised-button color="primary" id="submit"> Submit
            </button>
          </li>
        }
        @if(getMainTabName() === 'CAIS' && UserService.CAISFDIDRecordType === 'STAGING'){
          <li>
            <button matTooltip="Send to Submitted State" matTooltipPosition="left" class="resizeMatMenuBtn" [ngClass]="'btn-blue'" 
              (click)="sendToSubmitState();"
              mat-raised-button color="primary" id="sendSubmitStateBtn"> Send to Submitted
            </button>
          </li>
        }
        @if(this.isActive_submenu == 'Finra Exception' || this.isActive_submenu == 'Exception'){
          <li>
            <button matTooltip="Fetch Finra Feedback" [matTooltipShowDelay]="1000" matTooltipPosition="left" class="resizeMatMenuBtn" [ngClass]="'btn-blue'" 
             (click)="fileProcessing('Fetch')"
              mat-raised-button color="primary" id="Fetch"> Fetch
            </button>
          </li>
        }
        </span>
      }
      @if(getMainTabName() === 'My-Data-Viewer' && (this.isActive_submenu == 'Orders' || this.isActive_submenu == 'Trades' || this.isActive_submenu == 'Routes'
      || this.isActive_submenu == 'ACT Trades' || this.isActive_submenu == 'Allocations' || this.isActive_submenu == 'Client Data Exception')){
        <span
              class="nav nav-tabs table-container float-right display-no " >
              @if(!this.regUserInProduction && UserService.MPIDServiceList.createCatRoeService === 'true'){
          <li>
            <button
            (click)="fileProcessing('CAT'); isgenCATEvents='Y'"
             matTooltip="Create CAT ROEs" [matTooltipShowDelay]="1000" matTooltipPosition="left" class="grad-btn-create resizeMatMenuBtn" 
              mat-raised-button color="primary" id="submit"> Create CAT ROEs
            </button>
          </li>
        }
        </span>
      }
      </span>
    }
      </ul>
    </div>
  </div>
  </nav>

  <!-- DialogBox for File Operation -->
  <p-dialog [(visible)]="displayDialog" styleClass="quick-view-grid-row filterbox finraFilterbox" icon="pi pi-exclamation-triangle"
    width="425" appendTo="body" showEffect="fade" [modal]="true" [style]="{'min-height': 'auto'}" [ngClass]="isActive_submenu == 'Finra Exception' ? 'finraFilterbox' : 'filterbox'">
    <ng-template #header>
      File Operation :   {{fileProcessingType === 'CAT' ?  'Create ' + fileProcessingType + ' ROEs' : fileProcessingType}}
    </ng-template>
      <div class="col-lg-12">
      <span>
        <div class="col-md-12" [style]="{'margin': '15px 0px !important'}">
          <div class="col-md-6 topPadding">
            <h4 matSubheader class="textsize">Reporter:</h4>
          </div>
          <div class="col-md-6 topPadding">
            <h4 matSubheader class="textsize">{{this.UserService.getActiveMPID()}}</h4>
          </div>
        </div>
        <div>
          <mat-divider [style]="{'top': '55px !important'}"></mat-divider>
          <div class="col-md-12" [style]="{'margin': '10px 0px 15px 0px !important'}">
            <div class="col-md-6 topPadding">
              <h4 matSubheader class="textsize">
              {{(isActive_submenu == 'Finra Exception' && fileProcessingType === 'Submit') ? 'File Date:':'Report Date:'}}
            </h4>
            </div>
            <div class="col-md-6 topPadding">
              <app-datepicker-calendar [date]="reportDate" [isDateRange]="false" (dateChange)="getDateEmitter()"></app-datepicker-calendar>
            </div>
          </div>
          <mat-divider [style]="{'top': '104px !important'}"></mat-divider>
          @if(isActive_submenu != 'Finra Exception' && getMainTabName() !== 'CAIS'){
          <div>
            @if(isLoadingGroupList){
            <span class="col-md-12" style="text-align:center">Loading Group list
              <img style="text-align:center" alt="LoadingGroupList"
                src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
              <mat-divider></mat-divider>
            </span>
          }
          @if(!isLoadingGroupList){
            <div class="col-md-12" [style]="{'margin': '10px 0px 15px 0px !important'}">
              <div class="col-md-6 topPadding">
                <h4 matSubheader class="textsize">Group Name:</h4>
              </div>
              <div class="col-md-6 topPadding">
                <h4 matSubheader class="textsize">
                  <p-select class="dropDown" [options]="groupListDropDown" (onChange)="onGroupSelect($event)" [(ngModel)]="selectedGroup" appendTo="body"
                    [style]="{'text-transform': 'capitalize','width':'100%'}" placeholder="Select a Group" filter="true"
                    required="true">
                  </p-select>
                </h4>
              </div>
            </div>
          }
          </div>
        }


          @if((fileProcessingType=='CAT' || fileProcessingType=='Generate') && (isActive_submenu != 'Finra Exception' && getMainTabName() !== 'CAIS')){
          <div>
            <mat-divider [style]="{'top': ' 152px !important'}"></mat-divider>
            @if(isLoadingFileList){
            <span class="col-md-12" style="text-align:center">Loading File list
              <img style="text-align:center" alt="LoadingFileList"
                src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
              <mat-divider></mat-divider>
            </span>
          }
          @if(!isLoadingFileList){
            <div class="col-md-12">
              <div class="col-md-6 topPadding">
                <h4 matSubheader class="textsize">File Name:</h4>
              </div>
              <div class="col-md-6 topPadding">
                <h4 matSubheader class="textsize">
                  <p-multiSelect  id="FileNamedropDown" [options]="fileListDropDown" [(ngModel)]="selectedFiles" appendTo="body" styleClass = "file-multiselect"
                    [style]="{'text-transform': 'capitalize','width':'100%'}" placeholder="Choose" filter="true" panelStyleClass="filename-option-p-multiselect-panel"
                    required="true">
                  </p-multiSelect >
                </h4>
              </div>
            </div>
          }
          </div>
        }

        
       
        </div>
      
      </span>
    </div>
    <ng-template #footer>
      <p-button id="submit" [disabled]="isLoadingGroupList || isFileProcessingStated" class="nopadding"
        icon="fa fa-check" (click)="startFileProcessing()" label="Submit">
      </p-button>
      @if(isFileProcessingStated){
      <img style="text-align:center" alt="FileProcessingStated"
        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
      }
      </ng-template>
  </p-dialog>
  <!-- Notifications Dialog Box -->
   <p-dialog [(visible)]="isToastMessageHistory" height="auto" width="auto" 
    [style]="{'width':'26%','height':'100%','overflow-y': 'auto','max-height':'100%','padding':'0px','margin':'0px','border-radius':'0'}"
    (onHide)="isToastMessageHistory=false;"position="right" closeIcon="pi pi-times" 
    [focusOnShow]="false" styleClass="toastMessageHistory-dialog">
    <ng-template #header>
    <span class="headerSize">Notifications({{lastMessages.length}})</span>
    </ng-template>
     @if(lastMessages.length == 0){
        <strong class="no-data-message">No data</strong>
      }
    @for(item of lastMessages; track item;) {
      <div class="toastMessageAlign">
        <div class="circle-wrapper">
          <span class="circle-letter"
            [ngClass]="item.severity == 'error' ? 'errorClass' : item.severity == 'success' ? 'successClass' : item.severity == 'warn' ? 'warningClass' : 'infoClass'">
            {{item.severity == 'error' ? 'E' : item.severity == 'success' ? 'S' : item.severity == 'warn' ? 'W' :
            'I'}}</span>
        </div>
        <div class="msg-text">
          <strong class="fonttest" [ngClass]="!item.detail ? 'alignSummary' : ''">{{item.summary}}</strong>
            <span class="details">{{item.detail}}</span>
        </div>
      </div>
      <hr>
    }
  </p-dialog>
  <!-- Confirmation Dialog-Box -->
  <p-confirmDialog 
    id="information-confirmation-dialog" 
    header="Information" 
    key="submitInformationDialoge" 
    [baseZIndex]="999999"
    styleClass="information-confirmation-dialog"
    appendTo="body">
  </p-confirmDialog>
</div>